import { useState } from 'react';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { Link } from 'react-router';
import { analytics, useUser } from 'libs';
import { Alert } from 'components/common';

const FreeTrialBanner = () => {
  const { features, trial_ends_at } = useUser();
  const [isOpen, setIsOpen] = useState(true);

  if (!features.on_trial || !isOpen) return null;

  dayjs.extend(isBetween);
  const now = dayjs();
  const inFiveDays = dayjs().add(5, 'days');
  const trialEndsAt = dayjs(trial_ends_at);

  if (!trialEndsAt.isBetween(now, inFiveDays)) return null;

  return (
    <Alert
      isDismissable
      onClose={() => {
        setIsOpen(false);
        analytics.upgrade.bannerHide('Free Trial');
      }}
      variant="primary-light"
    >
      <div className="text-black">
        Your trial ends on <span className="fw-bold">{trialEndsAt.format('dddd, MMMM D, YYYY')}.</span>{' '}
        <span>
          You can manage your subscriptions from the{' '}
          <Link className="fw-bold" to="/settings/subscriptions">
            Subscriptions page
          </Link>
          .
        </span>
      </div>
    </Alert>
  );
};

export default FreeTrialBanner;
